import * as React from 'react';
import { useFiltersContext } from '../contexts/filters';
const { __ } = wp.i18n;

const NoResults = ({ posts }) => {
	const { clearFilters } = useFiltersContext();

	if (!posts.length) {
		const handleOnClick = () => {
			clearFilters();
		};

		return (
			<div className="pfa-no-results">
				<h3 className="pfa-no-results__title">{__('No results found', 'wex')}</h3>
				<p
					className="pfa-no-results__description"
					dangerouslySetInnerHTML={{
						__html: __(
							'There are no results for search terms you&apos;ve added',
							'wex'
						),
					}}
				/>
				<button className="btn-primary pfa-no-results__clear" onClick={handleOnClick}>
					{__('Clear filters', 'wex')}
				</button>
			</div>
		);
	}

	return '';
};

NoResults.displayName = 'NoResults';

export default NoResults;
